export default __webpack_public_path__ + "static/media/gorin_gray_2.dae362f6.png";